import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M20.7305 5.5982L18.3413 3.25248C17.991 2.90698 17.4251 2.91607 17.0748 3.27975L3.26048 17.4996C3.08982 17.6632 3 17.8905 3 18.136V20.2635C3 20.7636 3.40419 21 3.8982 21H5.95509C6.18862 21 6.41318 20.9909 6.58383 20.8273L20.7305 6.88017C21.0898 6.52559 21.0898 5.95279 20.7305 5.5982ZM18.0898 7.13475L6.96108 18.3997C6.61078 18.7543 6.04491 18.7543 5.69461 18.3997C5.34431 18.0451 5.34431 17.4723 5.69461 17.1177L16.8234 5.85278C17.1737 5.49819 17.7395 5.49819 18.0898 5.85278C18.4401 6.20737 18.4401 6.78016 18.0898 7.13475Z' />
        </SvgIcon>
    );
});
